import { useNavigate } from "react-router-dom";
import MyPlaylists from "../my-playlists";
import SavedPlaylists from "../saved-playlists";
import './desktop-playlists-sidebar.scss';
import { useRef, useState } from "react";
import classNames from "classnames";
import useUserStore from "../../../../store/UserState";
import { useScreenSize } from "../../../../hooks";

const DesktopPlaylistsSidebar = () => {

    const navigate = useNavigate();
    const [searchOpen, setSearchOpen] = useState(false);
    const inputRef = useRef<HTMLInputElement>(null);
    const [searchText, setSearchText] = useState("");
    const user = useUserStore(state => state.state.user);
    const { width } = useScreenSize();

    const handleOpenInput = () => {
        setSearchOpen(true);
        inputRef.current?.focus();
    }

    return (
        <div className="desktop-playlists-sidebar">
            {user?.uid && <div className={classNames("desktop-playlists-sidebar__search", {
                "desktop-playlists-sidebar__search-open": searchOpen
            })}>
                <button
                    onClick={handleOpenInput}
                    className={classNames("desktop-playlists-sidebar__search-btn")}>
                    <i className="fa-solid fa-search"></i>
                </button>
                <input
                    placeholder="Buscar en playlists..."
                    ref={inputRef}
                    value={searchText}
                    onChange={e => setSearchText(e.target.value)}
                    onBlur={() => setSearchOpen(false)}
                    onKeyDown={e => {
                        if (e.key === "Escape") {
                            setSearchText("");
                            setSearchOpen(false);
                            inputRef.current?.blur();
                        }
                    }}
                    className={classNames("desktop-playlists-sidebar__search-input")}
                >
                </input>
            </div>}
            {width >= 1200 && width < 1450 && <div className="desktop-playlists-sidebar__my-playlists-header">
                <button
                    onClick={() => navigate('/my-library')}
                    className="navigate-library-button btn btn-link text-light"
                >
                    <i className="fa-solid fa-lines-leaning"></i>
                </button>
            </div>}
            <MyPlaylists
                searchQuery={searchText}
                headerOptions={
                    <button
                        onClick={() => navigate('/my-playlists')}
                        className="navigate-playlist-button btn btn-link text-light"
                        style={{ fontSize: '1.5rem' }}
                    >
                        <i className="fa-solid fa-arrow-right-long"></i>
                    </button>} />
            {
                user?.uid && <SavedPlaylists
                    searchQuery={searchText}
                    headerOptions={
                        <button
                            onClick={() => navigate('/saved-playlists')}
                            className="navigate-playlist-button btn btn-link text-light"
                            style={{ fontSize: '1.5rem' }}
                        >
                            <i className="fa-solid fa-arrow-right-long"></i>
                        </button>} />
            }
        </div >
    );
}

export default DesktopPlaylistsSidebar